<div class="component-main-navigation">

  <div class="component-main-navigation__label">Categories</div>

  <a class="component-main-navigation__item" (click)="hideMainNavigation()" routerLink="reports"
     [routerLinkActiveOptions]="{exact: true}" routerLinkActive="active">
    <span class="component-main-navigation__item-name">All reports</span>
    <span class="component-main-navigation__item-count">{{ allReportsCounter }}</span>
  </a>

  <a class="component-main-navigation__item" [class.has-children]="menu.child.length > 0"
     routerLinkActive="active" *ngFor="let menu of visibleItems">
    <span class="component-main-navigation__item-name"
          [routerLink]="['reports', menu.category_name]"
          (click)="hideMainNavigation()">{{ menu.category_name }}</span>
    <span class="component-main-navigation__item-count">{{ menu.count }}</span>
    <div class="component-main-navigation__children" *ngIf="menu.child.length > 0">
      <a class="component-main-navigation__item component-main-navigation__item--child"
         (click)="hideMainNavigation()"
         [routerLink]="['reports', submenu.name]"
         routerLinkActive="active" *ngFor="let submenu of menu.child">
        <span class="component-main-navigation__item-name">{{ submenu.name }}</span>
        <span class="component-main-navigation__item-count">{{ submenu.count }}</span>
      </a>
    </div>
  </a>

  <a *ngIf="hiddenCount > 0 && !showAllCategories"
     class="component-main-navigation__more-link" (click)="toggleShowAll()">
    + {{ hiddenCount }} more
  </a>
  <a *ngIf="showAllCategories && navigationItems?.length > VISIBLE_COUNT"
     class="component-main-navigation__more-link" (click)="toggleShowAll()">
    Show less
  </a>

  <div class="component-main-navigation__divider"></div>

  <a class="component-main-navigation__item component-main-navigation__item--dict"
     routerLink="/data-dictionary" routerLinkActive="active" (click)="hideMainNavigation()">
    <span class="component-main-navigation__item-name">
      <i class="ti ti-book-2"></i> Data Dictionary
    </span>
    <i class="ti ti-arrow-right component-main-navigation__item-arrow"></i>
  </a>

</div>
